import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Rating from '@mui/material/Rating';
import { jsx as _jsx } from "react/jsx-runtime";
let warnedOnce = false;
/**
 * @ignore - do not document.
 */

export default /*#__PURE__*/React.forwardRef(function DeprecatedRating(props, ref) {
  if (!warnedOnce) {
    console.warn(['MUI: The Rating component was moved from the lab to the core.', '', "You should use `import { Rating } from '@mui/material'`", "or `import Rating from '@mui/material/Rating'`"].join('\n'));
    warnedOnce = true;
  }

  return /*#__PURE__*/_jsx(Rating, _extends({
    ref: ref
  }, props));
});